import { Box } from '@mantine/core';

interface ImageStripSlideProps {
  src: string;
  positionX: number;
  height: number;
}

export function ImageStripSlide({
  src,
  positionX,
  height,
}: ImageStripSlideProps) {
  return (
    <Box
      style={{
        backgroundImage: `url(${src})`,
        width: 350,
        backgroundPositionX: `${positionX}%`,
        backgroundSize: 'cover',
        height: Math.min(250, height / 2.5),
      }}
    />
  );
}
